import React, { useState } from 'react';
import { Play } from 'lucide-react';
const FILM_VIDEO_URL = 'https://www.dropbox.com/scl/fi/sr1whmgc1vbvycdc7oyrm/a4463a8aec694be093fbbb2d62fcc1f0-2.mov?rlkey=9mu21n6oou91y84cr8j2dk7nw&st=s6as16mc&raw=1';
export function Film() {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  return <main className="relative h-screen w-screen overflow-hidden bg-black" data-id="element-193">
      {/* ASPECT RATIO WRAPPER */}
      <div className="absolute left-1/2 top-1/2 aspect-video w-[100vw] min-w-[177.77vh] -translate-x-1/2 -translate-y-1/2" data-id="element-194">
        <video src={FILM_VIDEO_URL} autoPlay muted loop playsInline onLoadedData={() => setIsVideoLoaded(true)} className="absolute inset-0 h-full w-full" data-id="element-195" />

        {/*
          All TV overlays are wrapped in a div that only fades in
          once the background video has loaded its first frame.
         */}
        <div className="absolute inset-0 transition-opacity duration-1000" style={{
        opacity: isVideoLoaded ? 1 : 0
      }} data-id="element-196">
          {/* YOUTUBE TV OVERLAY 1 (TOP RIGHT - LOCKED) */}
          <div className="group absolute z-10 overflow-hidden bg-black" style={{
          top: '16.8%',
          right: '32.1%',
          width: '18%',
          height: '20.9%',
          transform: 'rotate(0deg) skew(1.2deg)'
        }} data-id="element-197">
            <iframe src="https://www.youtube.com/embed/ArdZ9eSs4Lk?autoplay=1&mute=1&controls=0&loop=1&playlist=ArdZ9eSs4Lk&modestbranding=1" title="TV Broadcast 1" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" className="pointer-events-none h-full w-full scale-[1.2]" data-id="element-198" />

            <a href="https://youtu.be/ArdZ9eSs4Lk?si=XptmpN_2KBhmUwqH" target="_blank" rel="noopener noreferrer" className="absolute inset-0 z-20 flex items-center justify-center bg-black/20 backdrop-blur-[2px] transition-opacity duration-300 opacity-0 group-hover:opacity-100" data-id="element-199">
              <div className="flex h-12 w-12 items-center justify-center rounded-full border border-white/80 bg-black/60 text-white backdrop-blur-sm transition-transform group-hover:scale-110" data-id="element-200">
                <Play className="h-5 w-5 fill-current pl-0.5" data-id="element-201" />
              </div>
            </a>
          </div>

          {/* YOUTUBE TV OVERLAY 2 (MIDDLE - LOCKED) */}
          <div className="group absolute z-10 overflow-hidden bg-black" style={{
          top: '53.1%',
          right: '53.7%',
          width: '15.2%',
          height: '20%',
          transform: 'rotate(0deg) skew(-1.1deg)'
        }} data-id="element-202">
            <iframe src="https://www.youtube.com/embed/vxT84IubvIk?autoplay=1&mute=1&controls=0&loop=1&playlist=vxT84IubvIk&modestbranding=1" title="TV Broadcast 2" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" className="pointer-events-none h-full w-full" style={{
            transform: 'scale(1.3)'
          }} data-id="element-203" />

            <a href="https://youtu.be/vxT84IubvIk?si=ojpmlf8uzmZH41X-" target="_blank" rel="noopener noreferrer" className="absolute inset-0 z-20 flex items-center justify-center bg-black/20 backdrop-blur-[2px] transition-opacity duration-300 opacity-0 group-hover:opacity-100" data-id="element-204">
              <div className="flex h-12 w-12 items-center justify-center rounded-full border border-white/80 bg-black/60 text-white backdrop-blur-sm transition-transform group-hover:scale-110" data-id="element-205">
                <Play className="h-5 w-5 fill-current pl-0.5" data-id="element-206" />
              </div>
            </a>
          </div>

          {/* YOUTUBE TV OVERLAY 3 (SMALLEST - LOCKED) */}
          <div className="group absolute z-10 overflow-hidden bg-black" style={{
          top: '31.1%',
          right: '56%',
          width: '10%',
          height: '11.8%',
          transform: 'rotate(1.2deg) skew(-0.5deg)'
        }} data-id="element-207">
            <iframe src="https://www.youtube.com/embed/pBXuOpywkoI?autoplay=1&mute=1&controls=0&loop=1&playlist=pBXuOpywkoI&modestbranding=1" title="TV Broadcast 3" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" className="pointer-events-none h-full w-full" style={{
            transform: 'scale(1.2)'
          }} data-id="element-208" />

            <a href="https://youtu.be/pBXuOpywkoI?si=MvJijFrXtR0ILyZj" target="_blank" rel="noopener noreferrer" className="absolute inset-0 z-20 flex items-center justify-center bg-black/20 backdrop-blur-[2px] transition-opacity duration-300 opacity-0 group-hover:opacity-100" data-id="element-209">
              <div className="flex h-8 w-8 items-center justify-center rounded-full border border-white/80 bg-black/60 text-white backdrop-blur-sm transition-transform group-hover:scale-110" data-id="element-210">
                <Play className="h-3 w-3 fill-current pl-0.5" data-id="element-211" />
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute inset-0 z-20" style={{
      background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.55) 100%)'
    }} data-id="element-212" />
    </main>;
}